export class IoTsTypeError extends Error {
  public message: string;

  constructor(name: string, message: string) {
    super(name);

    this.message = message;
  }
}
